module.exports = __webpack_public_path__ + "static/media/ic-sort-az-white.6c6b9e43.svg";